module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_arrow2-a9a5876f275097f57d17cbd4030aeae6.svg";